export default __webpack_public_path__ + "static/media/intro.36642ca7.png";